export default __webpack_public_path__ + "tab4_videoda65b0.mp4";